<template>
  <div>
    <v-card>
      <v-toolbar dark dense color="#4cc7e8" class="pb-0 mb-0">
        Suppliers Statistics
        <v-spacer></v-spacer>
        <v-btn @click="expandedFilters = !expandedFilters" flat>
          <span v-if="expandedFilters">Hide Filters</span>
          <span v-if="!expandedFilters">Show Filters</span>
        </v-btn>
        <v-btn flat @click="resetFilters()">Clear Grid Filters</v-btn>
      </v-toolbar>
      <v-card-text>
        <v-slide-y-transition>
          <v-layout row wrap v-if="expandedFilters">
            <v-flex xs4>
              <v-text-field
                v-model="search"
                v-on:input="onQuickFilterChanged"
                label="Search"
                prepend-icon="mdi-magnify"
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-autocomplete
                v-model="agGridFilter.categoryFilter"
                label="Category Filter"
                small-chips
                multiple
                clearable
                :items="categories"
                item-text="name"
                item-value="id"
                @change="updateFilter"
              >
                <template #selection="{ item }">
                  <v-chip
                    class="pr-0"
                    color="#4cc7e8"
                    style="color: white; font-weight: bold"
                    small
                    >{{ item.name }}
                    <v-icon
                      color="white"
                      @click="removeCategory(item)"
                      style="
                        font-size: 12pt;
                        margin-right: -8px;
                        margin-left: 2px;
                      "
                      >mdi-close</v-icon
                    >
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex xs4>
              <v-autocomplete
                v-model="agGridFilter.subCategoryFilter"
                label="Sub Category Filter"
                small-chips
                multiple
                clearable
                :items="subCategories"
                item-text="name"
                item-value="id"
                @change="updateFilter"
              >
                <template #selection="{ item }">
                  <v-chip
                    class="pr-0"
                    color="#4cc7e8"
                    style="color: white; font-weight: bold"
                    small
                    >{{ item.name }}
                    <v-icon
                      color="white"
                      @click="removeSubCategory(item)"
                      style="
                        font-size: 12pt;
                        margin-right: -8px;
                        margin-left: 2px;
                      "
                      >mdi-close</v-icon
                    >
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
        </v-slide-y-transition>

        <v-layout row wrap>
          <v-flex xs12 class="py-0">
            <!-- STATS BAR -->
            <v-container
              grid-list-md
              text-xs-center
              style=" width: 100%; text-align: center; font-weight: bold;
              background: #4cc7e8; border-radius: 5px; color: white; "
              class="mb-2 pa-0"
            >
              <v-layout row wrap>
                <v-flex> Total Enq: {{ statsData.totalEnq }} </v-flex>
                <v-flex> Total Rev: {{ statsData.totalRev }} </v-flex>
                <v-flex> Total Rev: {{ statsData.totalRev }} </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
          <v-flex xs12 class="py-0">
            <ag-grid-vue
              :style="{ width, height }"
              class="ag-theme-alpine"
              :defaultColDef="defaultColDef"
              :columnDefs="columnDefs"
              :rowData="rowData"
              :animateRows="true"
              :rowBuffer="5"
              :pagination="true"
              :isExternalFilterPresent="isExternalFilterPresent"
              :doesExternalFilterPass="doesExternalFilterPass"
              rowSelection="multiple"
              :rowDeselection="true"
              @grid-ready="onGridReady"
              @cellDoubleClicked="onCellDoubleClick"
              @filterChanged="updateSumTotals"
            ></ag-grid-vue>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { AgGridVue } from "ag-grid-vue";

export default {
  props: ["year", "month"],
  components: {
    AgGridVue,
  },
  data: () => ({
    //AG-Grid
    columnDefs: null,
    rowData: null,
    pinnedBottomRowData: null,
    columnApi: null,
    gridApi: null,
    defaultColDef: {
      sortable: true,
      filter: true,
      resizable: true,
      autoHeight: true,
    },
    width: "100%",
    height: "650px",
    search: "",

    // Filters
    searchDebounce: null,
    agGridFilter: {
      yearFilter: "All",
      categoryFilter: [],
      subCategoryFilter: [],
    },
    yearFilterArray: ["All"],

    expandedFilters: true,
    statsData: {
      totalEnq: 0,
      totalRev: 0,
      totalUC: 0,
    },
  }),
  computed: {
    ...mapGetters({
      user: "user",
      userData: "user/userData",
      data: "stats/suppliersStats",
      combinedData: "stats/supplierCombinedStats",
      monthData: "stats/supplierMonthStats",
      aGGridActionMenu: "agGrid/aGGridActionMenu",
      selectedRowData: "agGrid/selectedRowData",
      categories: "categories/list",
      subCategories: "categories/subCategoryList",
    }),
  },
  watch: {
    data: function(oldSE, newSE) {
      this.filterSuppliersData();
    },
    year: function() {
      this.filterSuppliersData();
    },
    month: function() {
      this.filterSuppliersData();
    },
    expandedFilters: function() {
      if (this.expandedFilters == true) {
        this.height = "650px";
      } else {
        this.height = "750px";
      }
    },
  },
  mounted() {
    this.setYearFilterArray();
    this.columnDefs = [
      {
        headerName: "Supplier",
        field: "name",
      },
      {
        headerName: "Category",
        field: "category",
        valueFormatter: (params) => {
          let categories = JSON.parse(
            JSON.stringify(
              this.categories.filter((c) =>
                params.data.category.split(",").includes(c.id)
              )
            )
          );
          let categoryString = "";
          let first = true;
          categories.forEach((element) => {
            if (first) {
              categoryString = element.name;
              first = false;
            } else {
              categoryString = `${categoryString}, ${element.name}`;
            }
          });
          return categoryString;
        },
      },
      {
        headerName: "Sub Category",
        field: "subCategory",
        valueFormatter: (params) => {
          let categories = JSON.parse(
            JSON.stringify(
              this.categories.filter((c) =>
                params.data.category.split(",").includes(c.id)
              )
            )
          );
          let subCategories = [];
          let first = true;
          let subCategoryString = "";
          categories.forEach((category) => {
            let subCategory = category.children.filter((c) =>
              params.data.subCategory.split(",").includes(c.id)
            );
            subCategories = subCategories.concat(subCategory);
          });
          subCategories.forEach((subCat) => {
            if (first) {
              subCategoryString = subCat.name;
              first = false;
            } else {
              subCategoryString = `${subCategoryString}, ${subCat.name}`;
            }
          });
          return subCategoryString;
        },
      },
      {
        headerName: "Enq Total",
        field: "enquiriesCount",
        sort: "desc",
        comparator: numberComparator,
      },
      {
        headerName: "Historic %",
        field: "enquiriesPercent",
        comparator: numberComparator,
        valueFormatter: (params) =>
          `${parseFloat(params.data.enquiriesPercent).toFixed(1)}%`,
      },
      {
        headerName: "Revenue",
        field: "revenue",
        valueFormatter: (params) => `${formatter.format(params.data.revenue)}`,
        comparator: moneyComparator,
      },
      {
        headerName: "$UC",
        field: "cC",
        valueFormatter: (params) => `${formatter.format(params.data.cC)}`,
        comparator: moneyComparator,
      },
      {
        headerName: "$UC per Enq",
        field: "ccPerEnq",
        valueFormatter: (params) => `${formatter.format(params.data.ccPerEnq)}`,
        comparator: moneyComparator,
      },
    ];
    this.$store.dispatch("stats/loadSuppliersStats").then(() => {
      this.filterSuppliersData();
    });
  },
  methods: {
    updateSumTotals() {
      let model = this.gridApi.getModel();
      let rows = model.rowsToDisplay;
      this.statsData = {
        totalEnq: 0,
        totalRev: 0,
        totalUC: 0,
      };
      rows.forEach((row) => {
        if (row.data.impactInterestedStatus == "Prospecting") {
          this.statsData.prospectingBuyers += 1;
        } else if (row.data.impactInterestedStatus == "Open") {
          this.statsData.openBuyers += 1;
        } else if (row.data.impactInterestedStatus == "Not Interested") {
          this.statsData.notInterestedBuyers += 1;
        }

        this.statsData.totalEnq += 1;
        if (row.data.revenue != "") {
          this.statsData.totalRev += parseFloat(row.data.revenue);
        }
        if (row.data.cC != "") {
          this.statsData.totalUC += parseFloat(row.data.cC);
        }
      });
      this.statsData.totalUC = formatter.format(this.statsData.totalUC);
      this.statsData.totalRev = formatter.format(this.statsData.totalRev);
    },
    filterSuppliersData() {
      if (this.data.length > 0) {
        let filteredData = [];
        if (this.year == "Combined Years") {
          filteredData = JSON.parse(
            JSON.stringify(this.combinedData.filter((s) => s.business_id != ""))
          );
        } else {
          if (this.month == 0) {
            filteredData = JSON.parse(
              JSON.stringify(
                this.data.filter(
                  (s) => s.business_id != "" && s.year == this.year
                )
              )
            );
          } else {
            filteredData = JSON.parse(
              JSON.stringify(
                this.monthData.filter(
                  (s) =>
                    s.business_id != "" &&
                    s.year == this.year &&
                    s.month == this.month
                )
              )
            );
          }
        }
        this.setGridData(filteredData);
      }
    },
    setYearFilterArray() {
      let year = new Date().getFullYear();
      for (let i = year; i >= 2018; i--) {
        this.yearFilterArray.push(i);
      }
    },
    resetFilters() {
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();
    },
    updateFilter() {
      this.gridApi.onFilterChanged();
    },
    isExternalFilterPresent() {
      return true;
    },
    doesExternalFilterPass(node) {
      let passed = 0;
      // Category Filter
      if (
        this.agGridFilter.categoryFilter.length != 0 &&
        this.agGridFilter.categoryFilter != "0"
      ) {
        let foundMatch = node.data.category
          .split(",")
          .find((val) => this.agGridFilter.categoryFilter.includes(val));
        if (typeof foundMatch != "undefined") {
          passed += 1;
        }
      } else {
        passed += 1;
      }

      // Category Filter
      if (
        this.agGridFilter.subCategoryFilter.length != 0 &&
        this.agGridFilter.subCategoryFilter != "0"
      ) {
        let foundMatch = node.data.subCategory
          .split(",")
          .find((val) => this.agGridFilter.subCategoryFilter.includes(val));
        if (typeof foundMatch != "undefined") {
          passed += 1;
        }
      } else {
        passed += 1;
      }

      if (passed == 2) {
        return true;
      } else {
        return false;
      }
    },

    setGridData(data) {
      let rowData = JSON.parse(JSON.stringify(data));
      // rowData.pop();
      // const pinnedRow = [data[data.length - 1]];

      // this.gridApi.setPinnedBottomRowData(pinnedRow);
      setTimeout(() => {
        this.gridApi.setRowData(rowData);
        this.updateSumTotals();

        // var allColumnIds = [];
        // this.columnApi.getAllColumns().forEach(function (column) {
        //   if (column.colDef.suppressSizeToFit != true) {
        //     allColumnIds.push(column.colId);
        //   }
        // });
        // // this.gridApi.sizeColumnsToFit();
        // this.columnApi.autoSizeColumns(allColumnIds, false);
      }, 50);
    },
    onQuickFilterChanged() {
      clearTimeout(this.searchDebounce);

      this.searchDebounce = setTimeout(() => {
        this.gridApi.setQuickFilter(this.search);
      }, 150);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      if (this.data.length != 0) {
        this.setGridData(this.data);
      }
    },
    onCellDoubleClick(cell) {},
    updateAGGridActionMenu() {
      this.$store.dispatch("agGrid/setAGGridActionMenuState", {});
    },
    viewStockDetails() {
      this.open(this.selectedRowData);
    },
    busName(id) {
      let business = this.businesses.find((b) => b.id == id);
      if (typeof business != "undefined") {
        return business.name;
      } else {
        return "";
      }
    },
    formatDate(date) {
      return date.slice(0, 11);
    },
    toggleForm() {
      if (!this.formOpen) {
        this.formData = {};
      }
      // this.formOpen = !this.formOpen;
      this.$router.push("/admin/salesEnquiry");
      setTimeout(() => {
        this.setGridData(this.salesEnquiries);
      }, 200);
    },
    addClicked() {
      if (!this.formOpen) {
        this.formData = {};
      }
      // this.formOpen = !this.formOpen;
      this.$router.push("/admin/salesEnquiry/new");
    },
    open(business) {
      this.$router.push(`/admin/salesEnquiry/${business.id}`);
      if (!this.formOpen) {
        this.image = null;
        this.saving = false;
        this.formData = business;
        this.formOpen = true;
        this.checkIfAlreadyOpened();
      }
    },
    checkIfAlreadyOpened() {
      if (
        (this.formData.status == "Unopened" ||
          this.formData.status == "Opened") &&
        this.userData.business_id == this.formData.business_id
      ) {
        this.formData.status = "Viewed";
        let today = new Date();
        this.formData.enquiryOpened = `${today.getFullYear()}-${today.getMonth() +
          1}-${today.getDate()} ${today.getHours()}:${today.getMinutes()}:${today.getMinutes()}`;
        this.$store.dispatch("business/salesEnquirySave", this.formData);
      }
    },
    sendReply() {
      this.emailLoading = true;
      try {
        let business = this.businesses.find(
          (b) => b.id == this.formData.business_id
        );
        let payload = {
          id: this.formData.id,
          business_id: this.formData.business_id,
          reply: this.replyFormData.reply,
          copySelf: this.replyFormData.copySelf,
          customerEmail: this.formData.email,
          customerName: this.formData.fullName,
          businessEmail: business.email,
          businessName: business.name,
        };
        this.$store
          .dispatch("emailSending/salesEnquirySendReply", payload)
          .then((result) => {
            this.emailLoading = false;
            this.replyEmailDialog = false;
            this.formData.status = "Reply Sent";
            this.$store.dispatch("business/loadSalesEnquiries");
            if (result.Result == "Success") {
              this.$swal({
                title: "Success!",
                text: `Your email has been sent.`,
                type: "success",
                confirmButtonText: "Ok",
              });
            } else {
              this.$swal({
                title: "Error!",
                text: `An Error has occured, Please try again later.`,
                type: "success",
                confirmButtonText: "Ok",
              });
            }
          });
      } catch (error) {
        this.emailLoading = false;
        this.$swal({
          title: "Error!",
          text: `An Error has occured, Please try again later.`,
          type: "error",
          confirmButtonText: "Ok",
        });
      }
    },
    currentBusinessEmail() {
      try {
        let business = this.businesses.find(
          (b) => b.id == this.formData.business_id
        );
        return business.email;
      } catch (error) {
        return "Unknown";
      }
    },
    save() {
      this.saving = true;
      for (const [key, value] of Object.entries(this.formData)) {
        if (value == undefined || value == null) {
          delete this.formData[key];
        }
      }
      if (this.formData.hasOwnProperty("id")) {
        this.$store
          .dispatch("business/salesEnquirySave", this.formData)
          .then(() => {
            // this.$swal("Saved", "This Sales Enquiry has been Saved", "success");
            this.toggleForm();
            this.saving = false;
          });
      } else {
        this.$store
          .dispatch("business/salesEnquiryAdd", this.formData)
          .then(() => {
            // this.$swal(
            //   "Added",
            //   "The Sales Enquiry has been created",
            //   "success"
            // );
            this.toggleForm();
            this.saving = false;
          });
      }
    },
    deleteItem() {
      this.$swal
        .fire({
          icon: "warning",
          title: "Are you sure you want to delete this sale enquiry card?",
          showDenyButton: true,
          showCancelButton: true,
          cancelButtonText: `Don't Delete`,
          confirmButtonText: `Delete`,
          confirmButtonColor: "red",
        })
        .then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.deleting = true;
            this.$store
              .dispatch("business/deleteSalesEnquiry", this.formData.id)
              .then(() => {
                this.deleting = false;
                this.toggleForm();
                this.$swal(
                  "Deleted",
                  "The Sales Enquiry has been deleted",
                  "success"
                );
              });
          }
        });
    },
    duplicateSalesEnquiry() {
      let payload = JSON.parse(JSON.stringify(this.formData));
      delete payload.id;
      delete payload.dateOfEnquiry;
      payload.repeatSale = 1;
      for (const [key, value] of Object.entries(payload)) {
        if (value == undefined || value == null) {
          delete payload[key];
        }
      }
      this.$store.dispatch("business/salesEnquiryAdd", payload).then(() => {
        this.toggleForm();
        this.saving = false;
      });
    },
    removeCategory(cat) {
      const index = this.agGridFilter.categoryFilter.indexOf(cat.id);
      if (index > -1) {
        this.agGridFilter.categoryFilter.splice(index, 1);
      }
      this.updateFilter();
    },
    removeSubCategory(cat) {
      const index = this.agGridFilter.subCategoryFilter.indexOf(cat.id);
      if (index > -1) {
        this.agGridFilter.subCategoryFilter.splice(index, 1);
      }
      this.updateFilter();
    },
  },
  filters: {
    moment: function(date) {
      return moment
        .utc(date)
        .local()
        .format("MMM Do YYYY, h:mm a");
    },
  },
};
</script>

<style lang="css">
#stats-grid .ag-body-horizontal-scroll {
  display: none;
}
</style>
